import { get } from 'lodash';
import actions from './signupActionTypes';

const initialState = { currentStep: 1 };
export default (state = initialState, action = null) => {
    switch (action.type) {
        case actions.GET_MY_ACTIVITY_LOGS: {
            const activityObj = {
                ...state,
                myActivityLog: action.payload,
            };
            return activityObj;
        }
        case actions.SET_STEP_NUMBER:
            return { ...state, currentStep: action.payload };
        case actions.CONFIGURE_DOMAIN_REQUIREMENT:
            return { ...state, needDomain: action.payload };
        case actions.CONFIGURE_MAIL_REQUIREMENT:
            return { ...state, needMailServer: action.payload };
        case actions.SET_STATE_OPTIONS:
            return { ...state, stateData: action.payload };
        case actions.SET_FIRST_FORM_DATA:
            return { ...state, basicData: action.payload };
        case actions.UPDATE_BASIC_DETAILS_EMAIL: {
            return {
                ...state,
                basicData: {
                    ...get(state, 'basicData', {}),
                    email: get(action, 'payload.data.email'),
                },
            };
        }
        case actions.SET_OTP_VERIFIED:
            return { ...state, otpVerified: action.payload };
        case actions.SET_DOMAIN_SUGGESTIONS: {
            return { ...state, domainSuggestions: get(action, 'payload.data') };
        }
        case actions.SAVE_GET_DOMAIN_DATA: {
            return { ...state, getDomain: get(action, 'payload') };
        }
        case actions.SAVE_DOMAIN_DETAILS: {
            return { ...state, domainDetails: get(action, 'payload') };
        }
        case actions.GET_PRICING_DETAILS: {
            return { ...state, pricingData: get(action, 'payload') };
        }
        case actions.SAVE_PLAN_DETAILS: {
            return { ...state, planDetails: get(action, 'payload') };
        }
        case actions.BUSINESS_MAIL_VERIFY: {
            return { ...state, businessMailVerified: get(action, 'payload') };
        }
        case actions.PROCESS_CARD: {
            return { ...state, cardData: get(action, 'payload') };
        }
        case actions.BUSINESS_EMAIL: {
            return { ...state, businessMail: get(action, 'payload') };
        }
        case actions.TRIAL_SAVE: {
            return { ...state, trialFormData: get(action, 'payload') };
        }
        case actions.BUSINESS_MAIL_ERROR:
            return { ...state, businessMailError: get(action, 'payload') };
        case actions.SET_GET_DOMAIN_ERROR:
            return { ...state, domainPurchaseErrors: get(action, 'payload') };
        case actions.SET_STRIPE_ERROR:
            return { ...state, stripeErrorMsg: get(action, 'payload') };
        case actions.SET_PASSWORD:
            return {
                ...state,
                accPassword: get(action, 'payload', ''),
            };
        case actions.BUSINESS_MAIL_VERIFY_ERROR:
            return {
                ...state,
                businessMailVerifyErr: get(action, 'payload', false),
            };
        case actions.INFINCE_URL:
            return { ...state, infinceUrl: get(action, 'payload') };
        case actions.REGISTERED_DOMAIN_STATUS: 
            return { ...state, domainRegistered: get(action, 'payload') };
        case actions.SET_EMAIL_PASSWORD_ERROR:
            return {
                ...state,
                mailPasswordError: get(action, 'payload', false),
            };
        case actions.CLEAR:
            return {};
        default:
            return state;
    }
};
